import React from 'react';
import { Row, Col, Card, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const OrdenesVinculadas = ({ ordenesVinculadas }) => {
    if (!ordenesVinculadas || ordenesVinculadas.length === 0) return null;

    return (
        <Row className="mb-3">
            <Col md={12}>
                <Card className="shadow-sm border">
                    <Card.Body className="p-0">
                        <Table borderless className="mb-0 small" style={{ tableLayout: "fixed", width: "100%" }}>
                            <thead className="bg-success text-white">
                                <tr>
                                    <th className="py-1 px-2 text-center">ID Orden</th>
                                    <th className="py-1 px-2 text-center">Fecha Venta</th>
                                    <th className="py-1 px-2 text-center">Fecha Facturado</th>
                                    <th className="py-1 px-2 text-center">Usuario Facturador</th>
                                    <th className="py-1 px-2 text-center">Total</th>
                                    <th className="py-1 px-2 text-center">Moneda</th>
                                    <th className="py-1 px-2 text-center">Estado</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ordenesVinculadas.map((orden, index) => (
                                    <tr key={index} className="text-dark">
                                        <td className="px-2 text-center"><Link to={`/ordenes/detalle/${orden.idOrden}`}>{orden.idOrden}</Link></td>
                                        <td className="px-2 text-center">{new Date(orden.dFechaVenta).toLocaleDateString('es-MX')}</td>
                                        <td className="px-2 text-center">{new Date(orden.dCreatedDate).toLocaleDateString('es-MX')}</td>
                                        <td className="px-2 text-center">{orden.vCreatedUser}</td>
                                        <td className="px-2 text-center">{orden.dTotal}</td>
                                        <td className="px-2 text-center">{orden.vMoneda}</td>
                                        <td className="px-2 text-center">{orden.bIsPagada ? 'Pagada' : 'Pendiente'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
};

OrdenesVinculadas.propTypes = {
    ordenesVinculadas: PropTypes.array
};

export default OrdenesVinculadas;